import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import isValidTokenJudge from './isValidTokenJudge';

const RequireJudge = ({ children }) => {
    return isValidTokenJudge() ? children : <Navigate to="/signin" replace />;
};

RequireJudge.propTypes = {
    children: PropTypes.any,
};

export default RequireJudge;
